export default "__VITE_ASSET__c694ede3__"